module.exports = __webpack_public_path__ + "img/result_and_state_pic.2109e57e.jpg";